import React, { useState } from "react";
import { Line } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserTie, faUser, faMagic, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const PRODUCTS = [
  { id: 1, name: "Wedding Saree", price: 4999, category: "Wedding", stock: 5 },
  { id: 2, name: "Festive Kurta", price: 1999, category: "Festive", stock: 12 },
  { id: 3, name: "Formal Shirt", price: 1499, category: "Office", stock: 8 },
  { id: 4, name: "Casual Dress", price: 1299, category: "Casual", stock: 20 },
];

const INSIGHTS = {
  labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  datasets: [{ label: "Footfall", data: [30, 45, 60, 40, 80] }],
};

const ModeToggle = ({ mode, setMode }) => (
  <div className="flex justify-center gap-2 p-3">
    {["customer", "rangoli", "staff", "admin"].map((m) => (
      <button
        key={m}
        onClick={() => setMode(m)}
        className={`text-xs lg:text-sm px-3 py-2 rounded capitalize ${mode === m ? "bg-black text-white" : "bg-gray-200"}`}
      >
        {m}
      </button>
    ))}
  </div>
);

const AIStylist = ({ onRecommend }) => {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});

  const QUESTIONS = [
    { key: "occasion", text: "Occasion", options: ["Wedding", "Festive", "Office", "Casual"] },
    { key: "budget", text: "Budget", options: ["<2000", "2000-5000", ">5000"] },
  ];

  const handleAnswer = (value) => {
    const q = QUESTIONS[step];
    const newAnswers = { ...answers, [q.key]: value };
    setAnswers(newAnswers);

    if (step + 1 < QUESTIONS.length) setStep(step + 1);
    else onRecommend(newAnswers);
  };

  return (
    <div className="bg-white p-4 rounded shadow">
      <h2 className="font-bold mb-2 flex items-center gap-2"><FontAwesomeIcon icon={faMagic} /> AI Stylist</h2>
      <p className="mb-2 text-cyan-500 text-sm lg:text-lg">{QUESTIONS[step].text}</p>
      <div className="grid grid-cols-4 gap-2 place-items-center">
        {QUESTIONS[step].options.map((opt) => (
          <button key={opt} onClick={() => handleAnswer(opt)} className="px-3 py-1 text-xs lg:text-sm bg-gray-200 rounded">
            {opt}
          </button>
        ))}
      </div>
    </div>
  );
};

const WhatsAppSim = () => {
  const [chat, setChat] = useState([
    { from: "user", text: "Need festive wear under ₹5000" },
  ]);

  const reply = () => {
    setChat([...chat, { from: "ai", text: "Showing top festive options..." }]);
  };

  return (
    <div className="bg-green-50 p-4 rounded shadow">
      <h2 className="font-bold flex items-center gap-2"><FontAwesomeIcon icon={faWhatsapp} /> WhatsApp AI</h2>
      <div className="h-32 overflow-auto text-sm my-2">
        {chat.map((c, i) => (
          <div key={i} className={c.from === "user" ? "text-right" : "text-left"}>
            {c.text}
          </div>
        ))}
      </div>
      <button onClick={reply} className="bg-green-500 text-white text-xs lg:text-sm w-20 lg:w-24 px-3 py-1 rounded">Reply</button>
    </div>
  );
};

const ProductCard = ({ p, mode, addToCart }) => (
  <div className="bg-white p-3 rounded shadow">
    <h3 className="text-xs lg:text-sm font-semibold">{p.name}</h3>
    <p className="text-xs lg:text-sm">₹{p.price}</p>
    <p className="text-xs">Stock: {p.stock}</p>

    {mode === "customer" && (
      <button onClick={() => addToCart(p)} className="mt-2 bg-black text-white  text-xs lg:text-sm w-full px-2 py-1 rounded flex items-center gap-1">
        <FontAwesomeIcon icon={faShoppingCart} /> Add
      </button>
    )}

    {mode === "staff" && (
      <p className="text-xs text-blue-500 mt-2">Upsell: Suggest matching item</p>
    )}
  </div>
);

const ProductGrid = ({ mode, addToCart }) => (
  <div className="grid grid-cols-2 lg:grid-cols-3 gap-3">
    {PRODUCTS.map((p) => (
      <ProductCard key={p.id} p={p} mode={mode} addToCart={addToCart} />
    ))}
  </div>
);

const CustomerTabs = () => {
  const [activeTab, setActiveTab] = useState("tryon");

  const tabs = [
    { key: "tryon", label: "Virtual Try On" },
    { key: "fit", label: "Fit Advisor" },
    { key: "visitqr", label: "Scan Visit QR" },
    { key: "shopqr", label: "Scan Shop QR" },
    { key: "likedqr", label: "Scan Like QR" },
    { key: "shop", label: "View Shop" },
    { key: "orders", label: "My Order" },
    { key: "bills", label: "My Bills" },
    { key: "payments", label: "My Payments" },
    { key: "coupons", label: "My Coupons" },
    { key: "complaints", label: "My Complaints" },
  ];

  return (
    <div className="bg-white p-3 rounded shadow">
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-2">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`text-xs lg:text-sm px-2 py-2 rounded border ${activeTab === tab.key ? "bg-black text-white" : "bg-gray-100"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Dummy Content */}
      <div className="mt-3 text-xs bg-gray-50 p-2 rounded">
        {activeTab === "tryon" && <p className="text-xs lg:text-sm">Upload your photo for virtual try-on (AI simulation)</p>}
        {activeTab === "fit" && <p className="text-xs lg:text-sm">Get size & fit recommendations</p>}
        {activeTab === "visitqr" && <p className="text-xs lg:text-sm">Scan QR when Vsiit the shop to win prizes</p>}
        {activeTab === "shopqr" && <p className="text-xs lg:text-sm">Scan QR when finishshopping to win prizes</p>}
        {activeTab === "likedqr" && <p className="text-xs lg:text-sm">Scan QR when liked a product on display to win prizes</p>}
        {activeTab === "shop" && <p className="text-xs lg:text-sm">Browse full shop categories & collections</p>}
        {activeTab === "orders" && <p className="text-xs lg:text-sm">Track your orders & history</p>}
        {activeTab === "bills" && <p className="text-xs lg:text-sm">View all your purchase bills</p>}
        {activeTab === "payments" && <p className="text-xs lg:text-sm">Payment history & methods</p>}
        {activeTab === "coupons" && <p className="text-xs lg:text-sm">Available offers & coupons</p>}
        {activeTab === "complaints" && <p className="text-xs lg:text-sm">Raise and track complaints</p>}
      </div>
    </div>
  );
};

const StaffPanel = () => {
  const [activeTab, setActiveTab] = useState("attendance");
  const tabs = [
    { key: "attendance", label: "Attendance" },
    { key: "salary", label: "Salary" },
    { key: "chronicles", label: "Chronicles" },
    { key: "stid", label: "Talking ID Card" },
    { key: "deepthinking", label: "DeepThinking" },
    { key: "applause", label: "Applause" },
    { key: "complaints", label: "Complaints" },
  ];

  return (
    <div className="bg-yellow-100 p-3 rounded">
      <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 my-3">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`text-xs px-2 py-2 rounded border ${activeTab === tab.key ? "bg-black text-white" : "bg-white"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <h2 className="font-bold mb-4 text-cyan-400">Staff Suggestions</h2>
      <div className="bg-white p-2 rounded text-xs mb-3">
        {activeTab === "attendance" && <p className="text-xs lg:text-sm">View attendance & working hours</p>}
        {activeTab === "salary" && <p className="text-xs lg:text-sm">Salary details, incentives & payouts</p>}
        {activeTab === "chronicles" && <p className="text-xs lg:text-sm">Daily logs & work history</p>}
        {activeTab === "stid" && <p className="text-xs lg:text-sm">Staff digital identity & profile</p>}
        {activeTab === "deepthinking" && <p className="text-xs lg:text-sm">AI-driven performance insights</p>}
        {activeTab === "applause" && <p className="text-xs lg:text-sm">Recognition & rewards system</p>}
        {activeTab === "complaints" && <p className="text-xs lg:text-sm">Customer complaints & resolution tracking</p>}
      </div>
      <ul className="text-sm list-disc pl-5">
        <li className="text-gray-100">Bundle Shirt + Trouser</li>
        <li className="text-gray-100">Push festive combos</li>
      </ul>
    </div>
  );
};


const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState("attendance");
  const tabs = [
    { key: "complaints", label: "Complaints" },
    { key: "attendance", label: "Attendance" },
    { key: "masters", label: "Masters" },
    { key: "deepthinking", label: "DeepThinking" },
    { key: "dtc", label: "Talking Card" },
    { key: "chronicles", label: "Chronicles" },
    { key: "applause", label: "Staff Applause" },
  ];

  return (
    <div className="bg-white p-4 rounded shadow">
      <h2 className="font-bold mb-3 text-cyan-400">Store Insights</h2>
      <div className="grid grid-cols-3 lg:grid-cols-5 gap-2 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`text-xs px-2 py-2 rounded border ${activeTab === tab.key ? "bg-black text-white" : "bg-gray-100"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="mb-4 text-sm bg-gray-50 p-3 rounded">
        {activeTab === "complaints" && <p className="text-xs lg:text-sm">Customer complaints & resolution tracking</p>}
        {activeTab === "attendance" && <p className="text-xs lg:text-sm">Attendance tracking & staff presence analytics</p>}
        {activeTab === "masters" && <p className="text-xs lg:text-sm">Manage products, categories, pricing masters</p>}
        {activeTab === "deepthinking" && <p className="text-xs lg:text-sm">AI insights & deep analytics engine</p>}
        {activeTab === "dtc" && <p className="text-xs lg:text-sm">Digital Talking Cards for staff/customer profiles</p>}
        {activeTab === "chronicles" && <p className="text-xs lg:text-sm">Store activity logs & historical events</p>}
        {activeTab === "applause" && <p className="text-xs lg:text-sm">Staff recognition, rewards & performance highlights</p>}
      </div>
      <Line data={INSIGHTS} />
      <div className="mt-3 text-sm">
        <p className="text-xs lg:text-sm">Total Products: {PRODUCTS.length}</p>
        <p className="text-xs lg:text-sm">Low Stock Items: {PRODUCTS.filter(p => p.stock < 6).length}</p>
      </div>
    </div>
  );
};

const RangoliPlusPanel = () => {
  const [activeTab, setActiveTab] = useState("photo");

  return (
    <div className="min-h-[60vh] bg-white p-4 rounded shadow">
      <h2 className="font-bold mb-3 text-blue-500">Rangoli Rewards</h2>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-1 mb-4 places-items-center">
        <button onClick={() => setActiveTab("photo")} className={`w-full text-xs lg:text-sm px-3 py-1 rounded ${activeTab === "photo" ? "bg-black text-white" : "bg-gray-200"}`}>
          📸 Photo Can Win
        </button>
        <button onClick={() => setActiveTab("kharcho")} className={`text-xs lg:text-sm px-3 py-1 rounded ${activeTab === "kharcho" ? "bg-black text-white" : "bg-gray-200"}`}>
          💸 Kharcho Jeeto
        </button>
        <button onClick={() => setActiveTab("partners")} className={`text-xs lg:text-sm px-3 py-1 rounded ${activeTab === "partners" ? "bg-black text-white" : "bg-gray-200"}`}>
          🛍️ Partner Shops
        </button>
      </div>

      {activeTab === "photo" && (
        <div className="space-y-3">
          <p className="text-xs lg:text-sm">Upload your best look and win rewards.</p>
          <input type="file" className="text-xs lg:text-sm" />
          <button className="bg-black text-white px-3 py-1 rounded text-xs lg:text-sm w-32 lg:w-40">Upload Photo</button>
          <div className="text-xs lg:text-sm text-gray-500">Top photos will be featured & rewarded.</div>
        </div>
      )}

      {activeTab === "kharcho" && (
        <div className="space-y-3">
          <p className="text-xs lg:text-sm">Upload bills and win cashback.</p>
          <input type="file" className="text-xs lg:text-sm" />
          <button className="bg-black text-white px-3 py-1 rounded text-xs lg:text-sm w-32 lg:w-40">Upload Bill</button>
          <div className="text-xs lg:text-sm text-gray-500">Eligible categories: food, grocery, stationery.</div>
        </div>
      )}

      {activeTab === "partners" && (
        <div className="grid grid-cols-2 gap-3">
          {["Lingerie", "Bangles", "Tailor", "Perfumes"].map((p) => (
            <div key={p} className="border p-3 rounded text-center">
              <p className="text-xs lg:text-sm font-semibold">{p}</p>
              <button className="mt-2 bg-gray-200 px-2 py-1 rounded text-xs lg:text-sm w-32 lg:w-40">Shop</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


export default function RangoliHome() {
  const [mode, setMode] = useState("customer");
  const [cart, setCart] = useState([]);
  const [recommendation, setRecommendation] = useState(null);

  const addToCart = (p) => setCart([...cart, p]);

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      <div className="p-4 bg-gradient-to-r from-pink-500 to-red-500 text-white">
        <h1 className="text-xl lg:text-2xl font-bold">🎨 Rangoli</h1>
        <p className="flex justify-center text-sm lg:text-lg text-white">AI + Retail + Operations</p>
      </div>

      <ModeToggle mode={mode} setMode={setMode} />

      <div className="p-4 space-y-4">
        {mode === "customer" && (
          <>
            <CustomerTabs />
            <AIStylist onRecommend={setRecommendation} />
            {recommendation && (
              <div className="bg-green-100 p-3 rounded">
                Recommended for {recommendation.occasion}
              </div>
            )}
            <WhatsAppSim />
            <ProductGrid mode={mode} addToCart={addToCart} />
            <div className="bg-white p-3 rounded shadow">
              <h2 className="font-bold">Cart ({cart.length})</h2>
              {cart.map((c, i) => (
                <div key={i} className="text-sm">{c.name}</div>
              ))}
            </div>
          </>
        )}

        {mode === "rangoli" && (
          <>
            <RangoliPlusPanel />
          </>
        )}

        {mode === "staff" && (
          <>
            <StaffPanel />
            <ProductGrid mode={mode} />
          </>
        )}

        {mode === "admin" && <AdminPanel />}
      </div>

      <footer className="p-3 bg-black text-white text-center text-xs">
        Powered by Think5Whys Global DeepTech Solutions, Mumbai
      </footer>
    </div>
  );
}
